import { Client, Account, Databases, Storage, TablesDB } from "appwrite";

const client = new Client()
  .setEndpoint("https://fra.cloud.appwrite.io/v1")
  .setProject("69b45b8f002a4f77f29f");

export const DB_ID          = "69b45bd50003bcdc0239";
export const BUCKET_ID      = "69b45be50016ad2a322a";
export const PRODUCTS_TABLE = "products";
export const ORDERS_TABLE   = "orders";
export const USERS_TABLE    = "users";
export const CHATS_TABLE    = "chats";
export const MESSAGES_TABLE = "messages";
export const VISITORS_TABLE = "visitors";
export const CART_TABLE     = "cart_items";

export const account  = new Account(client);
export const databases = new Databases(client);
export const storage  = new Storage(client);
export const tablesDB = new TablesDB(client);

export { client };
export default client;
